import PsNavTop from '@/components/PsNavTop.vue';
import PsNavBottom from '@/components/PsNavBottom.vue';
export default {
  name: 'App',
  components: {
    PsNavTop,
    PsNavBottom
  }
};